import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-load-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './load-skeleton.component.html',
  styleUrl: './load-skeleton.component.css',
})
export class LoadSkeletonComponent {
  rows = input(5);
  columns = input(7);

  skeletonRows = computed(() => Array(this.rows()).fill(0));
  skeletonCols = computed(() => Array(this.columns()).fill(0));
}
